import React from 'react';
import { Divider } from 'antd';
import DatesOverride from 'components/Calendar/DatesOverride';

const DatesOverrideCard = () => {
    return (
        <div className="bg-white rounded-lg px-7 py-3 mt-7">
            <div className="text-gray-800 text-xl font-medium">Date and time override</div>
            <Divider />
            <DatesOverride />
        </div>
    );
};

export default DatesOverrideCard;
